export const WisdomIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none">
      <path
        d="M8.96912 7.5L5 9.79167V5.20833L8.96912 7.5Z"
        fill="#FFFFFF"
        fillOpacity="0.8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 15V0H10.8333C12.214 0 13.3333 1.11929 13.3333 2.5V12.5C13.3333 13.8807 12.214 15 10.8333 15H0ZM1.66667 1.66667H10.8333C11.2936 1.66667 11.6667 2.03976 11.6667 2.5V12.5C11.6667 12.9602 11.2936 13.3333 10.8333 13.3333H1.66667V1.66667Z"
        fill="#FFFFFF"
        fillOpacity="0.8"
      />
    </svg>
  );
};
